import { logError } from '@core/logging';
import { filterUnserializable, logInfo } from '@src/helpers';
import { postMessageWrapper } from './postMessageWrapper';
export var EventError;
(function (EventError) {
    EventError["API_TIMEOUT"] = "timeout";
    EventError["API_ERROR"] = "error";
})(EventError || (EventError = {}));
export var EventType;
(function (EventType) {
    EventType["FW_ERROR"] = "fw:error";
    EventType["FW_EMBEDFEED_ERROR"] = "fw:embed-feed:error";
    EventType["FW_EMBEDFEED_RENDER"] = "fw:embed-feed:render";
    EventType["FW_EMBEDFEED_CONTENTREADY"] = "fw:embed-feed:content-ready";
    EventType["FW_EMBEDFEED_IMPRESSION"] = "fw:embed-feed:impression";
    EventType["FW_EMBEDFEED_THUMBNAILLOAD"] = "fw:embed-feed:thumbnail-load";
    EventType["FW_EMBEDFEED_THUMBNAILCLICK"] = "fw:embed-feed:thumbnail-click";
    EventType["FW_FLOATINGBUTTON_RENDER"] = "fw:channel-button:render";
    EventType["FW_FLOATINGBUTTON_IMPRESSION"] = "fw:channel-button:impression";
    EventType["FW_STORYBLOCK_RENDER"] = "fw:storyblock:render";
    EventType["FW_STORYBLOCK_IMPRESSION"] = "fw:storyblock:impression";
    EventType["FW_PROGRAMMATICPLAYER_RENDER"] = "fw:programmatic-player:render";
    EventType["FW_PROGRAMMATICPLAYER_IMPRESSION"] = "fw:programmatic-player:impression";
    EventType["FW_VIDEO_IMPRESSION"] = "fw:video:impression";
    EventType["FW_VIDEO_START"] = "fw:video:start";
    EventType["FW_VIDEO_FIRSTQUARTILE"] = "fw:video:first-quartile";
    EventType["FW_VIDEO_MIDPOINT"] = "fw:video:midpoint";
    EventType["FW_VIDEO_THIRDQUARTILE"] = "fw:video:third-quartile";
    EventType["FW_VIDEO_COMPLETE"] = "fw:video:complete";
    EventType["FW_VIDEO_SESSION_ENDED"] = "fw:video:session";
    EventType["FW_VIDEO_AD_START"] = "fw:video:ad-start";
    EventType["FW_VIDEO_AD_SKIP"] = "fw:video:ad-skip";
    EventType["FW_VIDEO_AD_END"] = "fw:video:ad-end";
    EventType["FW_VIDEO_AD_START_ERROR"] = "fw:video:ad-start-error";
    EventType["FW_VIDEO_CLICK_CTA"] = "fw:video:click-cta";
    EventType["FW_VIDEO_CLICK_SHARE"] = "fw:video:click-share";
    EventType["FW_VIDEO_SHARE"] = "fw:video:share";
    EventType["FW_PLAYER_QUIT"] = "fw:player:quit";
    EventType["FW_PLAYER_TRANSITION"] = "fw:player:transition";
    EventType["FW_PLAYER_NAVIGATE"] = "fw:player:navigate";
    EventType["FW_SHOPPING_CONFIGURE"] = "fw:shopping:configure";
    EventType["FW_SHOPPING_HYDRATECART"] = "fw:shopping:hydrate-cart";
    EventType["FW_SHOPPING_HYDRATEPRODUCTS"] = "fw:shopping:hydrate-products";
    EventType["FW_SHOPPING_UPDATEQUANTITY"] = "fw:shopping:cart-updated";
    EventType["FW_SHOPPING_REQUESTCHECKOUT"] = "fw:shopping:request-checkout";
    EventType["FW_SHOPPING_PRODUCT_CLICKED"] = "fw:shopping:product-clicked";
    EventType["FW_SHOPPING_CLICK_SHOPPAY"] = "fw:shopping:clickshoppay";
    EventType["FW_SHOPPING_CLICK_BUY"] = "fw:shopping:click-buy";
    EventType["FW_SHOPPING_CLICK_CALCULATE_TOTAL"] = "fw:shopping:click-calculate-total";
    EventType["FW_SHOPPING_CLICK_PLACE_ORDER"] = "fw:shopping:click-place-order";
    EventType["FW_LIVESTREAM_USER_JOIN"] = "fw:livestream:join";
    EventType["FW_LIVESTREAM_QUIT"] = "fw:livestream:quit";
    EventType["FW_LIVESTREAM_SEND_CHAT"] = "fw:livestream:send-chat";
    EventType["FW_LIVESTREAM_SEND_HEART"] = "fw:livestream:send-heart";
    EventType["FW_LIVESTREAM_INTERACTION_SUBMIT_ANSWER"] = "fw:video:submit-answer";
    EventType["FW_LIVESTREAM_INTERACTION_SUBMIT_CHOICE"] = "fw:video:submit-choice";
})(EventType || (EventType = {}));
export const customEvent = ({ target, type, data, }) => {
    const types = typeof type !== 'object' ? [type] : type;
    types.forEach((type) => {
        var _a, _b, _c, _d, _e;
        postMessageWrapper(Object.assign(Object.assign({}, filterUnserializable(data)), { type }));
        try {
            document.dispatchEvent(new CustomEvent(type, {
                detail: data,
            }));
        }
        catch (err) {
            logError(err);
        }
        try {
            // Dispatch on widget target (HTMLElement | ShadowRoot)
            ;
            (_b = (((_a = target) === null || _a === void 0 ? void 0 : _a.host) || target)) === null || _b === void 0 ? void 0 : _b.dispatchEvent(new CustomEvent(type, {
                detail: data,
            }));
            if (typeof window !== 'undefined' &&
                ((_e = (_d = (_c = window === null || window === void 0 ? void 0 : window._fwn) === null || _c === void 0 ? void 0 : _c.console) === null || _d === void 0 ? void 0 : _d.instance) === null || _e === void 0 ? void 0 : _e.isOpen)) {
                logInfo('CustomEvent', type, data);
            }
        }
        catch (err) {
            logError(err);
        }
    });
};
